"use client";

import WishlistButton from "@features/account/components/wishlist/WishlistButton";
import AuthButton from "@features/auth/components/AuthButton";
import Cart from "@features/cart/components/Cart";

const Actions = () => {
  return (
    <div className="flex items-center gap-1">
      <AuthButton className="hidden md:flex" />
      <WishlistButton />
      <Cart />
    </div>
  );
};

export default Actions;
